import type { ReactElement } from "react"
import { Link, useParams } from "react-router"
import styled from "styled-components"
import { StateMessage } from "~/shared/ui"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.md};
`

interface PendingFeatureProps {
  readonly label: string
  readonly ticket: string
}

/**
 * A card links here so the routing seam is real, but the detail screens are
 * separate sub-tasks. Saying so beats a 404 or a fake page.
 */
export const PendingFeature = ({ label, ticket }: PendingFeatureProps): ReactElement => {
  const { id } = useParams()

  return (
    <Wrapper data-qa-hook="pending-feature">
      <StateMessage qaHook="pending-feature-message">
        {`${label} detail is not built yet (${ticket}). Requested id: ${id ?? "unknown"}.`}
      </StateMessage>
      <Link to="/" data-qa-hook="pending-feature-back">
        Back to the Digital Library
      </Link>
    </Wrapper>
  )
}
